export const LOAD_ORDERS = 'DOCTOR_OVERVIEW/LOAD_ORDERS';
export const LOAD_DOCTOR_DATA = 'DOCTOR_OVERVIEW/LOAD_DOCTOR_DATA';
export const LOAD_DOCTOR_LICENSES = 'DOCTOR_OVERVIEW/LOAD_DOCTOR_LICENSES';
export const LOAD_DOCTOR_PRODUCTS = 'DOCTOR_OVERVIEW/LOAD_DOCTOR_PRODUCTS';
export const LOAD_ORDERS_TOTAL = 'DOCTOR_OVERVIEW/LOAD_ORDERS_TOTAL';
